<template>
  <div>
    <div class="loadingLanguage" v-if="loadingLang"></div>
    <div v-else>
      <footer>
        <div class="cnt">
          <div class="footerTop">
            <div class="aboutCnt">
              <div class="logo">
                <img src="../assets/i-lead-logo.png">
                <h4>Indonesian Landmark Environmental Decision Portal (I-LEAD)</h4>
                <span>
                  <template v-if="lang && lang.code === 'id'">oleh</template>
                  <template v-if="lang && lang.code === 'en'">by</template>
                  Indonesian Center for Environmental Law
                </span>
              </div>
              <div class="footerAddress">{{lang.langs.footer_address.value}}</div>
            </div>
            <div class="footerMenu">
              <div class="menuItem about">
                <h4>{{lang.langs.footer_about_label.value}}</h4>
                <p>{{lang.langs.footer_about.value}}</p>
              </div>
              <div class="menuItem links">
                <h4>{{lang.langs.footer_website.value}}</h4>
                <div class="comunityCnt">
                  <li><a href="https://icel.or.id/"
                    target="_blank" class="icel"></a></li>
                  <li><a href="https://perpustakaan.icel.or.id/"
                    target="_blank" class="library"></a></li>
                  <li><a href="https://jhli.icel.or.id/index.php/jhli"
                    target="_blank" class="journal"></a></li>
                </div>
                <!-- <li><a class="mi" href="https://icel.or.id/" target="_blank">ICEL Website</a></li> -->
                <!-- <li><a class="mi" href="/static/terms">Terms</a></li> -->
                <!-- <li><a class="mi" href="/static/privacy">Privacy Policy</a></li> -->
                <!-- <li><div class="mi" v-on:click="openFeedback">Masukan</div></li> -->
              </div>
              <div class="menuItem comunity">
                <h4>{{lang.langs.footer_social_media.value}}</h4>
                <div class="comunityCnt">
                  <li><a href="https://www.instagram.com/icel_indo/"
                    target="_blank" class="ig"></a></li>
                  <li><a href="https://twitter.com/icel_indo?s=21"
                    target="_blank" class="tw"></a></li>
                  <li><a href="https://youtube.com/c/IndonesianCenterforEnvironmentalLaw"
                    target="_blank" class="yt"></a></li>
                  <li><a href="https://id.linkedin.com/company/indonesian-center-for-environmental-law"
                    target="_blank" class="li"></a></li>
                  <li><a href="https://www.facebook.com/icel.or.id"
                    target="_blank" class="fb"></a></li>
                  <li><a href="https://spoti.fi/3sGdvJP"
                    target="_blank" class="sp"></a></li>
                </div>
              </div>
            </div>
          </div>
          <div class="copyright">
            &copy; {{d.getFullYear()}} Indonesian Center for Environmental Law (ICEL)
          </div>
        </div>
      </footer>
      <Feedback ref="feedback"/>
      <div class="helpBlock" :class="{open: helpOpen}"
        v-on:click="helpOpen = !helpOpen">
        <span class="question"></span>
        <span class="close"></span>
      </div>
      <div class="helpMenu" :class="{open: helpOpen}">
        <h4>{{lang.langs.help_label.value}}</h4>
        <a :href="`/static/${parent.slug}/${item.slug}`" v-for="(item, i) in allBantuan" :key="i">
          <template v-if="lang && lang.code === 'id'">{{item.title}}</template>
          <template v-if="lang && lang.code === 'en'">{{item.titleEn}}</template>
        </a>
        <li v-on:click="openFeedback">
          <template v-if="lang && lang.code === 'id'">Hubungi Kami</template>
          <template v-if="lang && lang.code === 'en'">Contact Us</template>
        </li>
      </div>
      <div class="helpInfo" :class="{closed: helpInfoClose}"
        v-if="helpInfoOpen">{{lang.langs.need_help.value}}</div>
    </div>
  </div>
</template>

<script>
import Feedback from '@/components/Feedback.vue';

export default {
  components: { Feedback },
  data() {
    return {
      d: new Date(),
      helpOpen: false,
      helpInfoOpen: true,
      helpInfoClose: false,
      parent: null,
      allBantuan: [],

      /**
       * Language
       *
       */
      loadingLang: true,
      lang: null,
    };
  },
  methods: {
    openFeedback() {
      this.helpOpen = false;
      this.$refs.feedback.open();
    },
    getData() {
      this.$http.get(this.$config.uri(`content/all?parentId=${this.parent.id}`)).then((r) => {
        this.allBantuan = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {
    let lang = localStorage.getItem('portal_putusan_penting_icel_lang');
    if (!lang) lang = window.navigator.userLanguage || window.navigator.language;
    if (lang === 'en-US' || lang === 'en') lang = 'en';
    else if (lang === 'id-ID' || lang === 'id') lang = 'id';
    else lang = 'id';
    this.$http.get(this.$config.uri(`misc/lang/${lang}`)).then((rlang) => {
      this.loadingLang = false;
      this.lang = rlang.data.data;
      this.$http.get(this.$config.uri('content/parents')).then((r) => {
        if (r.data.status !== 200) return;
        this.parent = r.data.data[1]; // eslint-disable-line
        this.getData();
      });
      setTimeout(() => {
        this.helpInfoClose = true;
        setTimeout(() => {
          this.helpInfoOpen = false;
        }, 200);
      }, 1600);
    });
  },
};
</script>

<style scoped lang="scss">
.loadingLanguage{
  background-color: #115457;
  height: 400px;
}
.helpInfo{
  position: fixed;
  right: 100px; bottom: 40px;
  background-color: #eee;
  border-radius: 3px;
  padding: 6px 12px;
  color: #444;
  font-size: 14px;
  z-index: 9999;
  transition: all .2s ease;
  @media (max-width: 780px) {
    right: 90px;
  }
  &.closed{
    opacity: 0;
  }
}
.helpMenu{
  position: fixed;
  right: 30px; bottom: 100px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .2);
  border: #eee 1px solid;
  z-index: 9999;
  padding: 10px 0;
  min-width: 200px;
  transform: scale(0);
  transform-origin: right bottom;
  transition: all .3s ease;
  @media (max-width: 780px) {
    right: 20px;
  }
  &.open{
    transform: scale(1);
  }
  h4{
    padding: 6px 20px 10px;
    border-bottom: #eee 1px solid;
    margin: 0;
    font-size: 17px;
    color: #444;
  }
  li, a{
    padding: 8px 20px;
    color: #444;
    list-style: none;
    cursor: pointer;
    display: block;
    transition: all .3s ease;
    &:hover{
      background-color: #e7f5f1;
    }
  }
}
.helpBlock{
  position: fixed;
  right: 30px; bottom: 30px;
  background-color: #369d66;
  border-radius: 50% 50% 3px 50%;
  width: 60px; height: 60px;
  z-index: 9999;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
  text-align: center;
  color: #fff;
  font-size: 46px;
  cursor: pointer;
  transition: all .3s ease;
  // transform-origin: right bottom;
  @media (max-width: 780px) {
    right: 20px;
  }
  span{
    position: absolute;
    display: block;
    left: 0; right: 0; top: 0; bottom: 0;
    transition: all .3s ease;
    &.question{
      background-image: url(../assets/question2-white.png);
      background-size: 34px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    &.close{
      background-image: url(../assets/close-white.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
  }
  &:hover{
    background-color: #12b55e;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, .3);
    // transform: scale(1.06);
  }
  &.open{
    background-color: #115457;
    transform: rotate(180deg) !important;
    border-radius: 50%;
    span{
      &.question{
        opacity: 0;
      }
      &.close{
        opacity: 1;
      }
    }
  }
}
footer{
  background-color: #115457;
  padding: 100px 0 40px;
  color: #fff;
  // font-family: 'Inter', sans-serif;
  font-weight: 300;
  @media (max-width: 740px) {
    text-align: center;
    padding: 60px 0 20px;
  }
  .footerTop{
    display: flex;
    @media (max-width: 740px) {
      display: block;
    }
    .aboutCnt{
      width: 400px;
      max-width: 300px;
      margin-right: auto;
      @media (max-width: 1180px) {
        width: 300px;
      }
      @media (max-width: 980px) {
        width: 360px;
      }
      @media (max-width: 740px) {
        width: auto;
        max-width: none;
        margin: 0 0 40px;
      }
      .logo{
        position: relative;
        font-size: 20px;
        margin-bottom: 16px;
        // padding-left: 56px;
        @media (max-width: 740px) {
          padding: 0;
          margin-bottom: 22px;
        }
        img{
          // position: absolute;
          // left: 0; top: -10px;
          // width: 46px; height: auto;
          width: auto; height: 38px;
          margin: -10px 0 16px;
          @media (max-width: 740px) {
            // position: static;
            // margin: -10px auto 16px;
            // display: block;
            // width: 64px;
          }
        }
        h4{
          margin: 0;
          font-size: 18px;
          font-weight: inherit;
        }
        span{
          display: block;
          font-size: 14px;
        }
      }
      .footerAddress{
        margin: 0 0 16px;
        font-size: 15px;
        opacity: .65;
        // padding-left: 56px;
        white-space: pre-wrap;
        @media (max-width: 740px) {
          padding-left: 0;
        }
      }
    }
    .footerMenu{
      display: flex;
      flex-wrap: wrap;
      width: calc(100% - 400px);
      @media (max-width: 1180px) {
        width: calc(100% - 300px);
      }
      @media (max-width: 980px) {
        width: calc(100% - 360px);
      }
      @media (max-width: 740px) {
        display: block;
        width: auto;
      }
      .menuItem{
        width: 33.33333%;
        padding-left: 20px;
        box-sizing: border-box;
        @media (max-width: 740px) {
          width: auto;
        }
        @media (max-width: 740px) {
          margin-bottom: 40px;
        }
        &.about{
          width: 35%;
          @media (max-width: 980px) {
            padding: 0 0 20px;
            width: 100%;
          }
          @media (max-width: 740px) {
            padding: 0;
            width: auto;
          }
        }
        &.links{
          width: 25%;
          @media (max-width: 980px) {
            padding: 0;
            width: 40%;
          }
          @media (max-width: 740px) {
            width: auto;
          }
        }
        &.comunity{
          width: 40%;
          @media (max-width: 980px) {
            width: 60%;
          }
          @media (max-width: 740px) {
            width: auto;
          }
        }
        h4{
          font-size: 20px;
          font-weight: 300;
          margin: 0 0 16px;
        }
        li{
          list-style: none;
          cursor: pointer;
          padding: 0 0 16px;
          font-size: 15px;
          @media (max-width: 740px) {
            padding: 0 0 8px;
          }
          a{
            color: #fff;
            &:hover{
              opacity: 1;
            }
          }
        }
        p{
          margin: 0 0 16px;
          font-size: 15px;
          opacity: .65;
          white-space: pre-wrap;
        }
        .comunityCnt{
          display: flex;
          flex-wrap: wrap;
          @media (max-width: 740px) {
            justify-content: center;
          }
          li{
            a{
              display: block;
              width: 36px; height: 36px;
              border-radius: 50%;
              box-sizing: border-box;
              margin-right: 10px;
              opacity: 1;
              background-size: 36px auto;
              background-position: center;
              background-repeat: no-repeat;
              transition: all .3s ease;
              &:hover{
                box-shadow: 2px 2px 4px rgba(0, 0, 0, .3);
              }
              &.wa{
                background-image: url(../assets/ic-whatsapp.png);
              }
              &.tw{
                background-image: url(../assets/ic-twitter.png);
              }
              &.fb{
                background-image: url(../assets/ic-facebook.png);
              }
              &.flicker{
                background-image: url(../assets/ic-flickr.png);
              }
              &.yt{
                background-image: url(../assets/ic-youtube.png);
              }
              &.sp{
                background-image: url(../assets/ic-spotify.png);
              }
              &.li{
                background-image: url(../assets/ic-linkedin.png);
              }
              &.ig{
                background-image: url(../assets/ic-instagram.png);
              }
              &.icel{
                background-color: #fff;
                background-image: url(../assets/Icon-main.svg);
                background-size: 24px auto;
              }
              &.journal{
                background-color: #fff;
                background-image: url(../assets/Icon-journal.svg);
                background-size: 28px auto;
              }
              &.library{
                background-color: #fff;
                background-image: url(../assets/Icon-library.svg);
                background-size: 22px auto;
              }
            }
          }
        }
      }
    }
  }
  .copyright{
    font-size: 14px;
    opacity: .65;
    padding-top: 40px;
    // padding-left: 56px;
    @media (max-width: 740px) {
      padding: 10px 16px 0;
      margin-top: 40px;
    }
  }
}
</style>
